<div id="<%= dom_id feedback %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Abbr:</strong>
    <%= feedback.abbr %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Value:</strong>
    <%= feedback.value %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= feedback.order %>
  </div>
</div>
